<style lang="scss" scoped>
@import "$vars";
div {
  strong {
    display: block;
    margin-bottom: 10px !important
  }
  span {
    display: flex;
  }
  display: block;
  margin-bottom: 20px
}
.not-selfEvaluation {
  margin-top: 3rem
}

h3 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}

h2 {
  color: #4a4a4a !important;
}
</style>

<template>
  <main class="component-patients" v-if="loaded">
    <h2>Autoavaliação</h2>
    <hr />
    <div v-if="this.$route.params.patientType !== 'patient' || !this.hasSelfEvaluation">
      <h3 class="text-center not-selfEvaluation">Este paciente não possui autoavaliação</h3>
    </div>
    <div v-else v-for="(field, $index) of selfEvaluation" :key="$index">
      <strong>{{field.label}}</strong>
      <input disabled v-if="field.type === 'text'" :value="field.value" class="col-12 input-text" type="text" />
      <span v-if="field.type === 'radio'" >
        <label class="form-radio">
          <input disabled type="radio" :name="field.name" :checked="checkBool(field.value) === 1" /> Sim
          <i class="form-icon"></i>
        </label>
        <label class="form-radio">
          <input disabled type="radio" :name="field.name" :checked="checkBool(field.value) === 0" /> Não
          <i class="form-icon"></i>
        </label>
      </span>
    </div>
  </main>
</template>

<script>
export default {
  props: ['patient'],
  data () {
    return {
      loaded: false,
      hasSelfEvaluation: false,
      selfEvaluation: {
        kidney_problems: {
          label: 'Problemas renais',
          name: 'kidney_problems',
          type: 'text',
          value: null
        },
        joint_problems_or_rheumatism: {
          label: 'Problemas articulares ou reumatismo',
          name: 'joint_problems_or_rheumatism',
          type: 'text',
          value: null
        },
        heart_problems: {
          label: 'Problemas cardíacos',
          name: 'heart_problems',
          type: 'text',
          value: null
        },
        breathing_problems: {
          label: 'Problemas respiratórios',
          name: 'breathing_problems',
          type: 'text',
          value: null
        },
        stomach_problems: {
          label: 'Problemas gástricos',
          name: 'stomach_problems',
          type: 'text',
          value: null
        },
        allergies: {
          label: 'Alergias',
          name: 'allergies',
          type: 'text',
          value: null
        },
        is_hepatitis: {
          label: 'Hepatite',
          name: 'is_hepatitis',
          type: 'radio',
          value: null
        },
        is_pregnancy: {
          label: 'Gravidez',
          name: 'is_pregnancy',
          type: 'radio',
          value: null
        },
        is_diabetes: {
          label: 'Diabetes',
          name: 'is_diabetes',
          type: 'radio',
          value: null
        },
        is_healing_problems: {
          label: 'Problemas de cicatrização',
          name: 'is_healing_problems',
          type: 'radio',
          value: null
        },
        use_any_medication: {
          label: 'Faz uso de algum medicamento?',
          name: 'use_any_medication',
          type: 'text',
          value: null
        }
      }
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    this.$http.get(`/doctor/patient/${this.patient.id}/self_evaluation`, this.$store.getters.getAuthHeader).then(
      (res) => {
        if (res.data) {
          this.hasSelfEvaluation = true
          for (let field in res.data) {
            if (this.selfEvaluation[field]) {
              this.selfEvaluation[field].value = res.data[field]
            }
          }
        }
      }
    ).catch((err) => {
      console.log(err)
    }).finally(
      () => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      }
    )
  },
  methods: {
    checkBool (v) {
      if (v === false) {
        return 0
      } else if (v === true) {
        return 1
      }
      return null
    }
  }
}
</script>
